import BookmarkContainer from "../../../Components/Applications/Bookmark/BookmarkContainer";

const Bookmarks = () => {
  return <BookmarkContainer />;
};

export default Bookmarks;
